const store = new Map();

const callbacks = (binding, vnode) => {
    const ctx = vnode.context;
    const key = binding.name;
    return {
        focus: () => ctx[key] = true,
        blur: () => ctx[key] = false
    }
};

// XXX: workaround for delegating a nested input in a component
const target = el => el.getElementsByTagName('input')[0] || el;

const update = (el, binding) => {
    el = target(el)
    const focused = document.activeElement === el;
    if (binding.value && !focused) return el.focus();
    if (!binding.value && focused) return el.blur();
};

export default {

    update: update,

    inserted (el, binding, vnode) {
        store.set(el, callbacks(binding, vnode));
        const input = target(el);
        input.addEventListener('focus', store.get(el).focus);
        input.addEventListener('blur', store.get(el).blur);
        update(el, binding);
    },

    unbind (el) {
        el.removeEventListener('focus', store.get(el).focus);
        el.removeEventListener('blur', store.get(el).blur);
        store.delete(el);
    }

}
